import { colors } from './tokens.js';

export type VehicleStatus = 'moving' | 'stopped' | 'idle' | 'offline' | 'pending';

export interface StatusConfigEntry {
  color: string;
  label: string;      // i18n key
  bgClass: string;    // Tailwind class (web)
  icon: string;       // Lucide icon slug (resolved by StatusIndicator)
}

export const STATUS_CONFIG: Record<VehicleStatus, StatusConfigEntry> = {
  moving:  { color: colors.statusMoving,  label: 'status.moving',  bgClass: 'bg-emerald-500', icon: 'arrow-right' },
  stopped: { color: colors.statusStopped, label: 'status.stopped', bgClass: 'bg-slate-500',   icon: 'square' },
  idle:    { color: colors.statusIdle,    label: 'status.idle',    bgClass: 'bg-amber-500',   icon: 'pause' },
  offline: { color: colors.statusOffline, label: 'status.offline', bgClass: 'bg-red-600',     icon: 'wifi-off' },
  pending: { color: colors.statusPending, label: 'status.pending', bgClass: 'bg-violet-500',  icon: 'satellite-dish' },
};
